// extracted by mini-css-extract-plugin
module.exports = {"close":"styles_close__5t3R0","closeSvg":"styles_closeSvg__AUUlR","primary":"styles_primary__g08z1","inverted":"styles_inverted__p9dXx","show":"styles_show__0ytQ6"};